import app from 'flarum/forum/app';
/**
 * Flarum is a single-page app: the counters only see the first page load.
 * Report every in-app route change as a page view to Yandex Metrika and GA4.
 * Settings are read lazily: app.forum is not available while initializers run.
 */
export default function trackPageViews() {
  const original = m.route.set;
  let last = window.location.pathname + window.location.search;
  m.route.set = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const result = original.apply(this, args);
    setTimeout(() => {
      const url = window.location.pathname + window.location.search;
      if (url === last) return;
      const referer = last;
      last = url;
      const ymId = Number(app.forum?.attribute('nhYmId') || 0);
      const gaId = String(app.forum?.attribute('nhGaId') || '');
      if (ymId && typeof ym === 'function') {
        ym(ymId, 'hit', url, {
          title: document.title,
          referer
        });
      }
      if (gaId && typeof gtag === 'function') {
        gtag('event', 'page_view', {
          page_path: url,
          page_title: document.title,
          page_location: window.location.href
        });
      }
    }, 300);
    return result;
  };
}